import { ModalContainer, Page, useModel, useRoute } from "@bcm-dev/bcms-vite";
import Util from 'classes/Util';
import modals from "components/custom-ui/CustomModal/components";
import React, { useEffect, useState } from 'react';
import "./styles.css";
/**
 * @function EDEStatementsPageContainer
 * @param {STRING} className - Additional CSS class name that's pass to the component.
 * @param {React.Component} children - Content that's contained in this page.
 * @returns {React.Component}
 * @example
 * <EDEStatementsPageContainer className="some-class">
 *  <h1>Page content</h1>
 * </EDEStatementsPageContainer>
 */
export default function EDEStatementsPageContainer(props) {
  const navigate = useRoute();
  const className = props.className ?? "";
  const onClickProp = props.onClick instanceof Function ? { onClick: props.onClick } : {};
  const ignoreTrigger = props.ignoreTrigger ?? false;
  const [ didLoadMabi23Branding, setDidLoadMabi23Branding ] = useState(false);
  const model = useModel();
  
  window.addEventListener("message", evt => {
   if(evt.data.message === "force-global-route"){
    const { route, state } = evt.data.detail;

    navigate(route, { state: state ?? {} });
   }
    
  });

  // Send a message to MABI23 that this iframe loaded.
  window.parent.postMessage({ message: "abi22-iframe-did-load", abi22Branding: model.branding }, "*");

  useEffect(() => {
    try{
      if(window.parent){
        if(window.parent.document){
          if(window.parent.document.loadFrame && !ignoreTrigger){
            window.parent.document.loadFrame();
          }
        }
      }
    }
   catch (error) {
  
   }

    // Function that sets the MABI23 branding as a variable in this window so that any
    // component can access it in ABI22.
    const setMabi23Branding = evt => {
      if(evt.data.message) {
        if(evt.data.message.mabi23Branding && didLoadMabi23Branding === false) {
          const mabi23Branding = evt.data.message.mabi23Branding;
          const parser = new DOMParser();
          window.mabi23Branding = mabi23Branding;

          const mabiMenu = evt.data.message.mabiMenu;
          window.mabiMenu = parser.parseFromString(mabiMenu, "application/xml");;
          

        }
        if(evt.data.message.mabi23BrandingStyles && didLoadMabi23Branding === false) {
        
          var mabi23BrandingStyles =document.createElement("style")
          mabi23BrandingStyles.innerHTML =evt.data.message.mabi23BrandingStyles;
       
          mabi23BrandingStyles.setAttribute("id","mabi_branding")
      
        document.getElementsByTagName("head")[0].append(mabi23BrandingStyles);
      
           
        }
         setDidLoadMabi23Branding(true);
      }
    };

    // Listen to a message from MABI23 which sends the branding for that demo
    // in order to access it in this demo. For now, we are using this code to 
    // access "ad" branding set in the MABI23 branding form.
    window.addEventListener("message", setMabi23Branding);

    return () => {
      window.removeEventListener("message", setMabi23Branding);
    }
  }, []);

  return(
    <Page className={className+ (!Util.inMabi?" abi-page":" mabi-page" )} isActive="false" state={ props.state } controller={ props.controller }>
      <ModalContainer modals={ modals }>
        <div className="ede-statements-page-container flex-container flex-vertical" { ...onClickProp }>
          {props.children}
        </div>
      </ModalContainer>
    </Page>
  );
}
